"use strict";

import Vue from 'vue';
import axios from 'axios';
// import axios from '@/utils/api/_axios.js'
import createApiInstance from '@core_utils/api/custom.instance.js'
import { refreshAccessToken, isRefreshableAuthError } from '@core_utils/api/tokenRefresh';

// raw axios(default 인스턴스)도 401 시 refresh→재시도. 재시도 요청에만 토큰을 붙이고, 백엔드
// origin 요청만 대상이다(isRefreshableAuthError). custom.instance.js 와 동일한 공유 dedup 헬퍼를 쓴다.
// 주의: store.js 는 raw axios 가 아니라 _axios.js 인스턴스를 쓴다. raw axios 는 S3·presigned URL
// 호출용이므로 axios.defaults 에 Authorization 을 넣지 말 것(S3 가 400 으로 거부 — tokenRefresh.js 참조).
axios.interceptors.response.use(
    (res) => res,
    async (error) => {
        if (error.response && error.response.status === 401) {
            const _cfg = error.config || {};
            if (isRefreshableAuthError(_cfg)) {
                _cfg._retriedWithRefresh = true;
                try {
                    const _newToken = await refreshAccessToken();
                    _cfg.headers = _cfg.headers || {};
                    _cfg.headers['Authorization'] = `Bearer ${_newToken}`;
                    return axios(_cfg);
                } catch (_refreshError) {
                    // refresh 실패 → 원 에러 전파(기존 로그아웃 처리로 폴백)
                }
            }
        }
        return Promise.reject(error);
    }
);

Vue.use({
  install (Vue) {
    // baseURL: `${apiBaseURL}/${path}`
    // window.axios = axios;

    const _axios_instance = createApiInstance()

    Vue.prototype.axios = _axios_instance
    Vue.prototype.$axios = _axios_instance
  }
})


